import api from './api';
export default {

    post: (processAreas) => api.post('/api/masterprojectsbyprocessarea', { processAreas }),

};